module.exports = __webpack_public_path__ + "img/product-7-mobileqinyou.e78aaf5c.png";